import React from "react";

const ITEMS = [
  { label: "NIFTY 50", value: "24,687.20", change: "+0.42%", up: true },
  { label: "BANK NIFTY", value: "52,114.85", change: "+0.71%", up: true },
  { label: "SENSEX", value: "81,240.55", change: "-0.12%", up: false },
  { label: "INDIA VIX", value: "13.92", change: "-1.84%", up: false },
  { label: "USD/INR", value: "83.41", change: "+0.08%", up: true },
  { label: "FIN NIFTY", value: "23,556.70", change: "+0.54%", up: true },
  { label: "GOLD", value: "73,220", change: "+0.22%", up: true },
  { label: "CRUDE", value: "6,418", change: "-0.95%", up: false },
];

export default function Ticker() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="market-ticker"
      className="relative border-y border-[#e2e8f0] bg-[#f8fafc] overflow-hidden"
    >
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#f8fafc] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#f8fafc] to-transparent z-10 pointer-events-none" />
        <div className="flex ticker py-4 gap-10 whitespace-nowrap">
          {loop.map((it, i) => (
            <div key={i} className="flex items-center gap-3 font-mono text-sm">
              <span className="text-[#475569] tracking-wide">{it.label}</span>
              <span className="font-bold text-[#0f172a]">{it.value}</span>
              <span className={it.up ? "text-[#10b981]" : "text-[#ef4444]"}>
                {it.up ? "▲" : "▼"} {it.change}
              </span>
              <span className="text-[#cbd5e1]">•</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
